import { render, staticRenderFns } from "./NewJobRegistration.vue?vue&type=template&id=0d77135e&"
import script from "./NewJobRegistration.vue?vue&type=script&lang=js&"
export * from "./NewJobRegistration.vue?vue&type=script&lang=js&"
import style0 from "./NewJobRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports